import {Employees} from "../../../../../server/src/base/entities/employee/Employees";
import {Employee} from "../../../../../server/src/base/entities/employee/Employee";

export abstract class IEmployeesService {
    abstract GetAll():Promise<Employees>;
    abstract Add(employee:Employee, file:File):Promise<Employee>;
    abstract Remove(employee:Employee):Promise<void>;
}

export class FakeEmployeesService implements IEmployeesService{

    Add(employee: Employee, file:File): Promise<Employee> {
        return Promise.resolve(employee);
    }

    GetAll(): Promise<Employees> {
        return Promise.resolve(new Employees(this.CreateEmployees()));
    }

    Remove(employee: Employee): Promise<void> {
        return Promise.resolve();
    }

    private CreateEmployees():Array<Employee>{
        let employees:Array<Employee> = [];
        for(let i = 0 ; i < 10 ; ++i){
            employees.push(new Employee().AsFake());
        }
        return employees;
    }

}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/employees/IEmployeesService.ts